module.exports = __webpack_public_path__ + "media/images/features/support/heading-mv-35dff2f23eb1e163d4d30941082e2b98.svg";